module.exports = __webpack_public_path__ + "img/logo.27d49066.png";